import React from 'react'
import {
  StyledGroup,
  StyledCheckbox,
} from '../../../components/UIElements/FilterCheckBoxComp/style'
import Flex from 'components/Flex'

const FilterCheckBoxComp = ({
  value,
  options,
  onChange,
  valueParam = 'value',
  labelParam = 'label',
  onChangeCheck,
  disabled,
}) => {


  return (
    <StyledGroup value={value} onChange={onChange} disabled={disabled}>
      {options?.map((item, index) => (
        <Flex spaceBetween centerVertically key={index+"option"}>
          <StyledCheckbox
            isAdded={item?.isAdded}
            value={item[valueParam]}
            label={item[labelParam]}
            onChange={onChangeCheck}
          />
        </Flex>
      ))}
    </StyledGroup>
  )
}

export default FilterCheckBoxComp
